import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';

const Row = styled(View)`
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
`;

const VendorButton = styled(Pressable)`
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.selected ? colors.header : 'gray'};
  border-radius: 6px;
  padding: 8px 16px;
  background-color: ${props => props.selected ? colors.header : 'white'};
`;

const VendorButtonText = styled(Text)`
  color: ${props => props.selected ? 'white' : 'black'};
  font-weight: 600;
`;

const VendorSelect = ({ vendors, selectedVendorId, onSelect }) => {
  if (!vendors || vendors.length < 2) {
    return null;
  }

  return (
    <Row>
      {vendors.map(vendor => {
        const selected = vendor.id === selectedVendorId;

        return (
          <VendorButton
            key={vendor.id}
            selected={selected}
            onPress={() => onSelect(vendor.id)}
          >
            <VendorButtonText selected={selected}>
              {vendor.name}
            </VendorButtonText>
          </VendorButton>
        );
      })}
    </Row>
  );
};

export default VendorSelect;
